export default "__VITE_ASSET__C1UUl0iu__"